export const MAX_PASSPORT_LENGTH = 20;
